import React, { useEffect, useState } from "react";
import Page from "./Page";
import { useAuth } from "./components/AuthContext/AuthContext";
import ToastMessage from "./stories/Toasts/ToastMessage";

function App() {
  let isLoggedIn = JSON.parse(localStorage.getItem("isLoggedIn"));
  const [isActivation, setIsActivation] = useState(false);
  const auth = useAuth();

  useEffect(() => {
    // Check for conditional rendering of LoggedInLayout.
    globalThis.location.pathname.includes("/my-account")
      ? setIsActivation(true)
      : setIsActivation(false);
  }, [isActivation, isLoggedIn, auth.isAuthenticated]);

  return (
    <>
      <Page />
      <ToastMessage newToast={auth?.toast} className={auth?.toast?.className} />
    </>
  );
}
export default App;
